import { render } from "./NavegacionAdmin.vue?vue&type=template&id=38d56004"
import script from "./NavegacionAdmin.vue?vue&type=script&lang=js"
export * from "./NavegacionAdmin.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__